import { TAPIResponse } from '@marketplace/api';

export type TAuthHook = TAPIResponse;

export type TAuthHookParams = {
  search?: string;
};

export enum USER_ROLES {
  USER = 'USER',
  ADMIN = 'ADMIN'
}

export type TParsedToken = {
  "scope": string,
  "client_id": string,
  "iss": string,
  "role": USER_ROLES,
  "familyName": string,
  "givenName": string,
  "oid": string,
  "uuid": string,
  "email": string,
  "username": string,
  "exp": number,
  "groups":any
}


export enum USER_AD_GROUPS {
  AD_GRP_ADMIN = "FHIRDevPlatform Admin",
  AD_GRP_SUPPORT = "FHIRDevPlatform Support",
  AD_GRP_USER = "FHIRDevPlatform User"
}